"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

exports.propertiesToSnakeCase = function (object, bodyParams) {
  var updatedObject = {};
  var keys = lodash_1.default.keys(object);
  keys.forEach(function (key) {
    var value = object[key];

    if (lodash_1.default.isArray(value) && !bodyParams) {
      updatedObject[lodash_1.default.snakeCase(key)] = value.join();
    } else updatedObject[lodash_1.default.snakeCase(key)] = value;
  });
  return updatedObject;
};